/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgenciesResponse } from '../../models/agencies-response';

export interface GetApiPublicAgencies$Params {
  '_locale': 'de' | 'en' | 'fr';
}

export function getApiPublicAgencies(http: HttpClient, rootUrl: string, params: GetApiPublicAgencies$Params, context?: HttpContext): Observable<StrictHttpResponse<AgenciesResponse>> {
  const rb = new RequestBuilder(rootUrl, getApiPublicAgencies.PATH, 'get');
  if (params) {
    rb.path('_locale', params['_locale'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgenciesResponse>;
    })
  );
}

getApiPublicAgencies.PATH = '/api/public/{_locale}/agencies';
